import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'


export default function reportForm() {

  const plans = ref([])
  

  const filterPlans=(planType)=>{
   

  

    ReportService.getPlanOptions({
      type:"plan",
       planType:planType,
       cols:"id,name",
       user: store.state.auth.userData.id
     }).then(response =>{ plans.value = response.data})
   
  }


  ReportService.getPlanOptions({
   type:"plan",
    planType:'dump',
    cols:"id,name",
    user: store.state.auth.userData.id
  }).then(response =>{   plans.value = response.data})

 
 



  return {
    plans,
    filterPlans,
   

  }
}
